<template>
  <div class="card snapshot">
    <div class="snapshot__header">
      <h4 class="title">
        {{ translate('snapshot.new_snapshot') }}
      </h4>
    </div>

    <div class="snapshot__content">
      <label> {{ translate('snapshot.orders.question' )}} </label>
      <div class="line">
        <tree-select
          :options="order_list"
          :placeholder="translate('snapshot.orders.question')"
          v-model="params.client_order_id"
          :multiple="false"
          :clearable="false"
          :max-height="310"
          @input="check_order()"
        />
      </div>

      <div class="add_block">
        <div class="form-group">
          <label>{{ translate('device.desc') }}</label>
          <textarea
              v-model="params.description"
              rows="10"
              class="form-control border-input"
              :placeholder="translate('device.desc')"
          />
        </div>
      </div>
    </div>

    <div class="snapshot__button">
      <button
        class="btn btn-success btn-fill btn-wd"
        :disabled="!check_answer"
        @click.prevent="save"
      >
        {{ translate('snapshot.to_add') }}
      </button>
      <button
        class="btn btn-danger btn-fill btn-wd"
        @click.prevent="cancel"
      >
        {{ translate('close_modal') }}
      </button>
    </div>
  </div>
</template>
<script>

export default {
  name: "NewSnapshot",

  props: ['profile_id', 'fid'],
  data () {
    return {
      order_list: [],
      params:{
        client_order_id: null,
        description: null
      },
      check_answer: false,
    }
  },
  computed:{
  },
  created () {
    this.get_order_list()
  },

  methods: {
    check_order(){
      this.check_answer = false
      if (this.params.client_order_id !== ''){
        let params = {
          device_id: this.profile_id,
          client_order_id: this.params.client_order_id,
        }
        this.$http.v1.checkClientOrder( params,(response) => {
          if (response) this.check_answer = true;
        })
      }
    },
    cancel () {
      this.$emit('close')
    },
    save () {
      this.$emit('take', this.params)
    },
    get_order_list(){
      this.$http.v1.getAvailableOrdersForSnapshot(this.fid, (response) => {
        this.order_list = response.data.map((order) => {
          return {id: order.id, label: order.name}
        })
        if (this.order_list.length === 1) this.params.client_order_id = this.order_list[0].id
      })
    }
  }
}

</script>

<style lang='scss' scoped>

  .snapshot{
    &__header{
      padding: 20px 10px 10px;
      .title{
        font-size: 22px;
        font-weight: 600;
        text-align: center;
      }
    }
    &__content{
      padding: 10px;
      .line {
        //margin-bottom: 10px;
        //padding: 0 15px 0;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        margin-bottom: 10px;
        button {
          height: 40px;
        }

      }
      .add_block{
        .form-group{
          margin-bottom: 0;
        }
        textarea{
          flex: 10;
          width: 100%;
          height: 100%;
          overflow: auto;
          outline: none;
          &::-webkit-scrollbar {
            width: 10px;
          }
        }
      }


    }
    &__button{
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 15px;
      .btn{
        margin: 0 5px;
      }
    }
  }
  @media (max-width:600px) {
    .snapshot{
      &__form{
        &-row{
          flex-direction: column;
          &__input{
            width: 100%;
          }
        }
      }
    }
  }

</style>
